import axios from "axios";

const endpoint_url = "/message/whatsappMessageTemplate/detail";

const getWhatsappMessageTemplateDetail = (whatsappMessageTemplateUuid) => {
  const params = new URLSearchParams([['whatsapp_message_template_uuid', whatsappMessageTemplateUuid]]);

  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, { params })
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getWhatsappMessageTemplateDetail;
